import axios from "~/plugins/axios";

export default {
  getIndex() {
    const url = "/web_api/v1/analysis";

    return axios.get(url).then((response) => response.data);
  },
  getScenarioCalculationValues(routeParams) {
    return axios
      .get("/web_api/v1/analysis/scenarios", { params: routeParams })
      .then((response) => response.data);
  },
  calculateScenarios(overrides, routeParams) {
    return axios
      .post("/web_api/v1/analysis/scenarios", overrides, {
        params: routeParams,
      })
      .then((response) => response.data);
  },
  saveScenarios(overrides, routeParams) {
    return axios
      .post("/web_api/v1/analysis/scenarios", overrides, {
        params: { save: 1, ...routeParams },
      })
      .then((response) => response.data);
  },
  scenariosPDF(overrides, routeParams) {
    return axios
      .post("/web_api/v1/analysis/scenarios/pdf", overrides, {
        params: routeParams,
      })
      .then((response) => response.data);
  },
};
